import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const OccupationalTherapy = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="occupational therapy icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M16 6C17.6569 6 19 4.65685 19 3C19 1.34315 17.6569 0 16 0C14.3431 0 13 1.34315 13 3C13 4.65685 14.3431 6 16 6Z"
    />
    <path
      className={pathClass}
      d="M21 23V15H3.00001V23C3.00001 23.5523 2.5523 24 2.00001 24C1.44773 24 1.00001 23.5523 1.00001 23V15C1.00001 14.8765 0.981323 14.3567 1.26368 13.8779C1.61091 13.2892 2.23836 13 3.00001 13H21C21.6321 13 22.3071 13.1579 22.707 13.7578C22.9512 14.1241 22.9939 14.5477 23 14.8057V23C23 23.5523 22.5523 24 22 24C21.4477 24 21 23.5523 21 23Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 15L6.99997 22.5C6.9499 23.2792 7.5 24 8.50005 24C9.65577 24 9.94995 23.2013 10 22.5L10.5 15"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 14.9829L12.1462 19L11.8962 22.5C11.8962 23.5 12.627 24 13.3962 24C14.0885 24 14.8962 23.5 14.8962 22.5L15.1462 18.75L13.5256 14.97"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.75 13C7.75 13 9.0403 6.54127 10.8242 5.58035C12.0276 4.93596 13.1465 5.61426 13.7482 6.13429C14.0332 6.3717 14.2443 6.67694 14.3921 7.0387L17 13C16 13 15 13 14.5 13L13.5 11L13 13"
    />
  </svg>
)
